import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// react query
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import queryClient from 'react-query/queryClient';
import { dashboardPersistOptions } from 'react-query/dashboardPersistOptions';

ReactDOM.render(
  <React.StrictMode>
    <PersistQueryClientProvider client={queryClient} persistOptions={dashboardPersistOptions}>
      <App />
    </PersistQueryClientProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
